import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import ListCd from './ListCd';

import {
    filialCentroDistribuicaoSeller, filialCentroDistribuicaoSellerComFiltro, gerarExelFilialCentroDistribuicaoSeller
}
    from '../../../services/http/SellerAdminstradorService/filialCdSellerService';

import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../hooks/snackBar';
import { saveAs } from 'file-saver';

import services from '../../../services';

import './styles.scss';

const PerfilSellerCd = () => {

    const { addSnackBar } = useSnackBar();
    const { idSeller } = services.storage.getUser();
    const history = useHistory();
    const [busca, setBusca] = useState('');
    const [empresaResponse, setEmpresas] = useState(
        {
            numeroPagina: 0,
            totalPaginas: 0,
            lista: [],
            tamanhoPagina: 0,
            hasPreviousPage: false,
            hasNextPage: false
        });

    const subSellerPage = (idCdSeller) => {
        history.push(`/seller/filial-cd/${idCdSeller}`);
    }

    const CarregarListaCds = (pagina) => {
        trackPromise(
            filialCentroDistribuicaoSeller(pagina, idSeller)
                .then(res => {
                    if (res.data) {
                        setEmpresas(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar lista', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar lista', info: 'error', open: true });
        })
    }

    const CarregarListaCdsComFiltro = (filtro, pagina) => {
        trackPromise(
            filialCentroDistribuicaoSellerComFiltro(idSeller, filtro, pagina)
                .then(res => {
                    if (res.data) {
                        setEmpresas(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar lista', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar lista', info: 'error', open: true });
        })
    }

    const extrairBase = () => {
        trackPromise(
            gerarExelFilialCentroDistribuicaoSeller(idSeller)
                .then(res => {
                    if (res.data) {
                        saveAs(res.data, "cadastros.xlsx")

                    } else {
                        addSnackBar({ message: 'Não foi possível extrair a base', info: 'warning', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano extrair a base', info: 'error', open: true });
        })
    }

    const mudarPaginaCdSeller = (page) => {
        busca != "" ? CarregarListaCdsComFiltro(busca, page) : CarregarListaCds(page);
    }

    const buscar = (filtro) => {
        setBusca(filtro);
    }

    useEffect(() => {
        if (busca != "") {
            const delayDebounceFn = setTimeout(() => {
                CarregarListaCdsComFiltro(busca, 1);
            }, 2000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            CarregarListaCds(1);
        }

    }, [busca]);

    useEffect(() => {
        const { idSeller } = services.storage.getUser();

        if (!idSeller) {
            addSnackBar({
                message: 'Erro ao tentar buscar lista',
                info: 'error',
                open: true
            });

            history.push('/home');
        }

        CarregarListaCds(1)
    }, []);

    return (
        <div>
            <div className='row mt-1 ml-1 titulo'>
                Cadastro de Filiais / CDs
            </div>
            <div className='row mt20  ml-1 '>
                <h1 className='label-second'>Filiais e CDs Cadastrados</h1>
            </div>

            <div className='row'>
                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button
                        onClick={() => history.push('/seller/filial-cd/cadastro')}
                        className="buton-green btn btn-block btn-lg mt20">
                        CADASTRAR FILIAL / CD
                    </button>
                </div>

                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button className="buton-white-black-border btn btn-block btn-lg mt20" onClick={extrairBase}>
                        EXTRAIR BASE
                    </button>
                </div>
            </div>
            <ListCd
                subSellerPage={subSellerPage}
                response={empresaResponse}
                mudarPagina={mudarPaginaCdSeller}
                buscar={buscar}
                busca={busca}
            />

        </div>
    );
}

export default PerfilSellerCd;